import type { ReactNode } from "react";
import { PageHeader } from "./ui/PageHeader";
import { Feedback } from "./ui/Surface";
import { stageLabels, type Issuance, type IssuanceStatus, type Stage } from "../types";
import { issuanceDisplayStatus, issuanceStatusLabels } from "../issuanceStatus";
import "./WorkflowShared.css";
import { usePlanningBaseline } from "./ui/DesignSystem";

export const stageTone: Record<Stage, string> = {
  prep: "mint",
  sewing: "sewing",
  finish: "finish"
};

export const statusLabel: Record<IssuanceStatus, string> = {
  issued: issuanceStatusLabels.issued,
  in_progress: issuanceStatusLabels.in_progress,
  inspection_pending: issuanceStatusLabels.inspection_pending,
  completed: issuanceStatusLabels.completed
};

export function WorkflowPage({
  eyebrow,
  title,
  titleAction,
  actions,
  tabs,
  className,
  children
}: {
  eyebrow?: string;
  title: ReactNode;
  titleAction?: ReactNode;
  actions?: ReactNode;
  tabs?: ReactNode;
  className?: string;
  children: ReactNode;
}) {
  return (
    <main className={`workflow-page${className ? ` ${className}` : ""}`}>
      <PageHeader title={title} titleAction={titleAction} eyebrow={eyebrow} actions={actions} tabs={tabs} className="workflow-heading" />
      {children}
    </main>
  );
}

export function StageBadge({ stage }: { stage: Stage }) {
  const baseline = usePlanningBaseline();
  const tone = baseline ? { prep: "mint", sewing: "blue", finish: "pink" }[stage] : stageTone[stage];
  return <span className={`stage-badge ${tone}`}>{stageLabels[stage]}</span>;
}

export function IssuanceStatusLabel({ issuance, className = "" }: { issuance?: Issuance; className?: string }) {
  const status = issuance && issuanceDisplayStatus(issuance);
  return <span className={`record-status ${status ?? ""} ${className}`}>
    {status ? issuanceStatusLabels[status] : "—"}
  </span>;
}

export function Notice({ tone = "success", children }: { tone?: "success" | "error" | "info"; children: ReactNode }) {
  return <Feedback tone={tone}>{children}</Feedback>;
}
